import React from 'react';
import { HiPhone, HiLocationMarker } from './Icons';
import type { PromotionFormData } from './PromotionForm';
import './PromotionPreview.css';

interface PromotionPreviewProps {
  data: PromotionFormData | null;
}

const PromotionPreview: React.FC<PromotionPreviewProps> = ({ data }) => {
  if (!data) {
    return (
      <div className="promotion-preview">
        <h3 className="preview-title">Live Preview</h3>
        <div className="preview-card preview-placeholder">
          <p>Fill the form to see how your promotion will look.</p>
        </div>
      </div>
    );
  }
  const imageUrl = data.image_urls?.length
    ? data.image_urls.filter(Boolean)[0]
    : data.image_url || data.cover_photo_url;
  const typeLabel = data.promotion_type === 'story' ? 'Story' : data.promotion_type === 'spotlight' ? 'Spotlight' : 'Category';

  return (
    <div className="promotion-preview">
      <h3 className="preview-title">Live Preview</h3>
      <div className="preview-card">
        {imageUrl && (
          <div className="preview-image-wrap">
            <img src={imageUrl} alt="Preview" className="preview-image" />
          </div>
        )}
        <div className="preview-body">
          <span className="preview-type-badge">{typeLabel}</span>
          <h4 className="preview-card-title">{data.title || 'Promotion title'}</h4>
          {data.brand_name && <p className="preview-brand">{data.brand_name}</p>}
          {data.description && <p className="preview-desc">{data.description}</p>}
          <div className="preview-offers">
            {data.discount_percentage && (
              <span className="preview-discount">{data.discount_percentage}% off</span>
            )}
            {data.discount_amount && (
              <span className="preview-discount">₹{data.discount_amount} off</span>
            )}
            {data.coupon_code && (
              <span className="preview-coupon">Code: {data.coupon_code}</span>
            )}
          </div>
          {(data.valid_from || data.valid_to) && (
            <p className="preview-dates">
              {data.valid_from && new Date(data.valid_from).toLocaleDateString()}
              {data.valid_from && data.valid_to && ' – '}
              {data.valid_to && new Date(data.valid_to).toLocaleDateString()}
            </p>
          )}
          {(data.call_button_enabled === 1 || data.mobile_number) && (
            <p className="preview-contact"><HiPhone size={16} /> {data.mobile_number || 'Call'}</p>
          )}
          {data.show_location === 1 && data.location_address && (
            <p className="preview-location"><HiLocationMarker size={16} /> {data.location_address}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromotionPreview;
